export const returnMessageFromCode = (code) => {
      switch (code) {
        case '9000':
          alert('기본 요청 정보가 없습니다.');
          break;
        case '9001':
          alert('상점키가 없습니다.');
          break;
        case '9002':
          alert('검색된 상점키가 없습니다.');
          break;
        case '9003':
          alert('라이센스키가 없습니다.');
          break;
        case '9004':
          alert('검색된 라이센스키가 없습니다.');
          break;
        case '9005':
          alert('허가된 업체가 아닙니다.');
          break;
        case '9006':
          alert('API 연동이 초과되었습니다.');
          break;
        case '9007':
          alert('API 조회 권한이 없습니다. 상점에 문의해 주시기 바랍니다.');
          break;
        case '9008':
          alert('API 조회 권한이 없습니다. 메이크샵 담당자에게 문의해 주시기 바랍니다.');
          break;
        case '9009':
          alert('허가된 IP가 아닙니다.');
          break;
        case '9011':
          alert('검색된 내역이 없습니다.');
          break;
        case '9012':
          alert('조회 시작일이 없습니다.');
          break;
        case '9013':
          alert('조회 시작일 날짜의 형식이 맞지 않습니다. 예) 0000-00-00 00:00:00');
          break;
        case '9014':
          alert('조회 시작일이 맞지 않습니다.');
          break;
        case '9015':
          alert('조회 종료일 날짜의 형식이 맞지 않습니다. 예) 0000-00-00 00:00:00');
          break;
        case '9016':
          alert('조회 종료일이 맞지 않습니다.');
          break;
        case '9017':
          alert('조회 기간을 확인해 주세요.');
          break;
        case '9018':
          alert('조회 기간은 30일을 초과할 수 없습니다.');
          break;
        case '9019':
          alert('조회 날짜 형식이 맞지 않습니다. 예) 0000-00-00');
          break;
        case '9021':
          alert('조회할 주문번호가 없습니다.');
          break;
        case '9031':
          alert('조회할 아이디가 없습니다.');
          break;
        case '9032':
          alert('조회는 1000개 이상 할 수 없습니다.');
          break;
        case '9033':
          alert('다중 조회 횟수를 초과하였습니다.');
          break;
        case '9034':
          alert('다중 검색 값이 배열이 아닙니다.');
          break;
        case '9041':
          alert('숫자가 아닙니다.');
          break;
        case '9051':
          alert('게시판 조회 코드가 필요합니다.');
          break;
        case '9061':
          alert('쿠폰 코드가 필요합니다.');
          break;
        case '9062':
          alert('쿠폰 검색타입이 필요합니다.');
          break;
        case '9063':
          alert('스마트쿠폰 적용 상점은 사용할수 없습니다.');
          break;
        case '9064':
          alert('스마트쿠폰 미적용 상점은 사용할수 없습니다.');
          break;
        case '9071':
          alert('상품번호가 없습니다.');
          break;
        case '9081':
          alert('서버 부하로 인한 조회 기간이 조정되었습니다. (최대 1일로 검색가능합니다.)');
          break;
        case '9101':
          alert('상점 관리자가 Open API 서비스 이용 동의를 하지 않았습니다.');
          break;
        case '9102':
          alert('상점 관리자가 Open API 제 3자 제공 동의를 하지 않았습니다.');
          break;
        case '9103':
          alert('API 처리 권한이 없습니다. 상점에 문의해 주시기 바랍니다.');
          break;
        case '9104':
          alert('API 처리 권한이 없습니다. 메이크샵 담당자에게 문의해 주시기 바랍니다.');
          break;
        case '9201':
          alert('datas 값이 없습니다.');
          break;
        case '9202':
          alert('datas 값이 배열이 아닙니다.');
          break;
        case '9203':
          alert('1회 최대 처리 한도를 초과하였습니다.');
          break;
        case '9204':
          alert('POST로 전달받은 값이 없습니다.');
          break;
        case '9221':
          alert('상품 준비중 리스트 미사용');
          break;
        case '9401':
          alert('디자인 버전 D4를 사용해야 합니다.');
          break;
        case '9901':
          alert('지원하지 않는 mode 입니다. (endpoint를 확인주시길 바랍니다.)');
          break;
        case '9902':
          alert('해당 기능(포인트, emoney 등)이 사용 안함 상태인 경우 출력됩니다. (상점 관리자를 통해 기능 상태를 사용함으로 변경해주세요.)');
          break;
        case '9997':
          alert('DB 등록 실패');
          break;
        case '9998':
          alert('상점 이용 기간이 만료되었습니다.');
          break;
        case '9999':
          alert('fail, message가 출력됩니다.');
          break;
        default:
          break;
      }
};
  